let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jerP3")).then(() => parcelRequire('68qgh'));